<template>
  <div class="booker" :class="shrinkedView ? 'booker-mini' : ''">
    <SingleSelection v-if="expandedDateTime" :expandedDateTimeMS="expandedDateTime" :matchPool="matchPool" :prefer24HourFormat="prefer24HourFormat" @clearExpanded="clearExpanded" @isLargeView="false" />
    <div v-else-if="!expandedDateTime && !shrinkedView" class="selected">
      <div class="title">Booking</div>
      <div @scroll="handleScroll" class="groups" id="groups">
        <div class="yearGroup" v-for="(yearGroup, y) in sortedSelections" :key="y">
          <div class="year">
            <span>{{ yearGroup.year }}</span>
          </div>
          <div class="monthGroup" v-for="(monthGroup, x) in yearGroup.months" :key="x">
            <div class="month">
              <span>{{ monthGroup.month }}</span>
            </div>
            <div class="dateGroup" v-for="(dateGroup, i) in monthGroup.dates" :key="i">
              <div class="date">
                <span>{{ dateGroup.dateNum }}</span>
                <span>{{ dateGroup.shortDate }}</span>
              </div>
              <div class="slot" @click="expandSlot($event, dateTimeMS)" v-for="(dateTimeMS, index) in dateGroup.selections" :id="dateTimeMS" :key="index">
                <div class="details" :class="isExpanded(dateTimeMS) ? 'expanded-details' : ''">
                  <div v-if="hasBestMatch(dateTimeMS)" class="profile">
                    <ik-image loading="lazy" :transformation="[{ height: 60, width: 60 }]" v-if="getBestMatch(dateTimeMS).profileImageUrl" :src="getBestMatch(dateTimeMS).profileImageUrl" class="picture" />
                    <div v-else class="picture smallBorder">
                      <IconBase icon-name="profile" iconColor="#333" viewBox="0 0 32 32" width="100%" height="100%" strokeWidth="0px"><IconProfileImg /></IconBase>
                    </div>
                    <div class="name">
                      {{ getBestMatch(dateTimeMS).displayName }}
                    </div>
                  </div>
                  <div v-else class="empty">No one here yet</div>
                  <div class="time">{{ getSlotTimes(dateTimeMS) }}</div>
                  <div class="cancel" @click="cancelSelection(dateTimeMS)">x</div>
                </div>
                <div v-if="isExpanded(dateTimeMS)" class="expanded">
                  <div>
                    Select stuff:
                    <br />
                    <div @click="toggleSelectionRematch(dateTimeMS)" :class="selectionSessionData[dateTimeMS].currentUserSession.rematch ? 'rematch' : ''">(green if rematch is allowed)</div>
                  </div>
                  <div v-if="hasBestMatch(dateTimeMS)">
                    <div>Current selection details</div>
                  </div>
                  <div v-if="hasMorePeople(dateTimeMS)">
                    <span>I have many people.</span>
                    <div v-for="(person, p) in getOtherAvailablePeople(dateTimeMS)" :key="p">
                      <div class="details">
                        <div class="profile">
                          <ik-image loading="lazy" :transformation="[{ height: 60, width: 60 }]" v-if="person.profileImageUrl" :src="person.profileImageUrl" class="picture" />
                          <div class="name">
                            {{ person.displayName }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>Looks like no one else is booked here!</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="actions" :class="shrinkedView ? 'actions-mini' : ''" v-if="selectedDateTimes && selectedDateTimes.length">
        <button class="confirm" :class="currentlyBooking ? 'disabled' : ''" :disabled="currentlyBooking == true" @click="bookManySessions">
          {{ returnBookButtonText }}
        </button>
        <div class="cancel" @click="cancelAllBookings">Cancel all</div>
      </div>
    </div>
    <div class="bookerMini" v-else-if="!expandedDateTime && shrinkedView">
      <div class="selections">
        <div v-for="(selection, index) in selectionSessionData" :key="index" class="selection">
          <div v-if="hasBestMatch(selection.dateTimeMS)" class="profile flex">
            <a :href="`/profile/${getBestMatch(selection.dateTimeMS).ID}`">
              <ik-image loading="lazy" :transformation="[{ height: 60, width: 60 }]" v-if="getBestMatch(selection.dateTimeMS).profileImageUrl" :src="getBestMatch(selection.dateTimeMS).profileImageUrl" class="picture" />
              <div v-else class="picture smallBorder">
                <IconBase icon-name="profile" iconColor="#333" viewBox="0 0 32 32" width="100%" height="100%" strokeWidth="0px"><IconProfileImg /></IconBase>
              </div>
            </a>
            <a :href="`/profile/${getBestMatch(selection.dateTimeMS).ID}`" class="name">
              {{ getBestMatch(selection.dateTimeMS).displayName }}
            </a>
          </div>
          <div v-else class="empty">No one here yet</div>
          <div class="time">{{ getSlotDateAndTime(selection.dateTimeMS) }}</div>
          <div class="cancel" @click="cancelSelection(selection.dateTimeMS)">x</div>
        </div>
      </div>
      <div class="actions" v-if="selectedDateTimes && selectedDateTimes.length">
        <button class="confirm" :class="currentlyBooking ? 'disabled' : ''" :disabled="currentlyBooking == true" @click="bookManySessions">
          {{ returnBookButtonText }}
        </button>
        <div class="cancelAll" @click="cancelAllBookings">Cancel all</div>
      </div>
    </div>

    <!-- <div v-if="!userHasUpcomingSessions" class="sessionless">
      <p class="title">You don't have any upcoming sessions this week..</p>
      <p class="subtitle">Book some to kickstart your productivity!</p>
    </div> -->
    <!-- <form v-if="selectedToBook && selectedToBook.length">
        <input
          class="booking-input"
          autocomplete="off"
          name="title"
          type="text"
          v-model="slotName"
          placeholder="Event title"
        /><br />
        <input
          class="booking-input"
          name="date"
          type="date"
          v-model="slotDateString"
          placeholder="Date"
        /><br />
        <input
          class="booking-input"
          name="start-time"
          type="time"
          v-model="slotStartTime"
          placeholder="Start time"
        /><br />
        <div class="all-users"></div>
      </form> -->
  </div>
</template>

<script>
import SingleSelection from "./SingleSelection";
import IconBase from "../../../../components/IconBase";
import IconProfileImg from "../../../../components/SVG/IconProfileImg";

/**
 * @todo !!! Currently, constantly redoing the entire
 * computation of getting people. This should probably be stored
 * in memory instead, and only be updated, if data itself has changed,
 * such as when a new person has been added.
 *
 * @abstract could be useful, though novel approaches
 * have been developed by now; nor do these problems exactly
 * match our scenario & our different variables:
 * https://en.wikipedia.org/wiki/Stable_marriage_problem
 * https://en.wikipedia.org/wiki/Gale%E2%80%93Shapley_algorithm
 *
 * @ux: list people > group people;
 *
 * @matching-variables:
 * mic, work type, screensharing, group belonging,
 * lists (favorites, fam, friends, etc),
 * activity type (coding, yoga, exercise)
 */

import { format, getYear, getMonth, getDate } from "date-fns";

import { formatSlotDate } from "../../../../utilities/dateFormatter";
import { SESSION_LENGTH_MS } from "../../../../constants_calendar";
import { StoreMatchController } from "../../../../store/calendar";

export default {
  name: "Booker",
  props: ["selectedDateTimes", "selectionSessionData", "currentlyBooking", "matchPool", "calendarUsers", "prefer24HourFormat", "shrinkedView"],
  data() {
    return {
      hasMounted: false,
      expandedDateTime: null,
    };
  },
  components: {
    IconBase,
    IconProfileImg,
    SingleSelection,
  },
  computed: {
    sortedSelections() {
      return generateSortedSelections(this.selectedDateTimes);
    },
    // slotName: {
    //   get() {
    //     return this.selectedSlotName;
    //   },
    //   set(value) {
    //     this.$store.dispatch("booking/setSelectedSlotName", value);
    //   },
    // },
    // slotDateString: {
    //   get() {
    //     return this.selectedSlotDateString;
    //   },
    //   set(value) {
    //     this.$store.dispatch("booking/setSelectedSlotDateString", value);
    //   },
    // },
    // slotStartTime: {
    //   get() {
    //     return this.selectedSlotStartTime;
    //   },
    //   set(value) {
    //     this.$store.dispatch("booking/setSelectedSlotStartTime", value);
    //   },
    // },
    returnBookButtonText() {
      let bookText = "";
      if (this.currentlyBooking) {
        bookText = "Booking...";
      } else if (!this.currentlyBooking && this.selectedDateTimes.length > 1) {
        bookText = `Book ${this.selectedDateTimes.length} sessions`;
      } else if (!this.currentlyBooking && this.selectedDateTimes.length < 2) {
        bookText = "Book session";
      }
      return bookText;
    },
  },
  methods: {
    handleScroll() {
      let element = document.querySelectorAll(".groups")[0];
      if (!element.classList.contains("scrolled")) {
        element.classList.add("scrolled");
      } else if (element.classList.contains("scrolled") && element.scrollTop == 0) {
        element.classList.remove("scrolled");
      }
    },

    expandSlot(event, dateTimeMS) {
      // Expand, unless click is for cancel selection
      if (!event.target.classList.contains("cancel")) {
        this.expandedDateTime = dateTimeMS;
      }
    },

    clearExpanded() {
      this.expandedDateTime = null;
    },

    isExpanded(dateTimeMS) {
      return this.expandedDateTime && this.expandedDateTime == dateTimeMS;
    },
    getSlotTimes(dateTimeMS) {
      const slotStartTime = formatSlotDate(dateTimeMS, this.prefer24HourFormat);
      const slotEndTime = formatSlotDate(dateTimeMS + SESSION_LENGTH_MS, this.prefer24HourFormat);
      return slotStartTime + "-" + slotEndTime;
    },

    getSlotDateAndTime(dateTimeMS) {
      const date = format(dateTimeMS, `MMMM d, y`);
      const times = this.getSlotTimes(dateTimeMS);
      return date + "—" + times;
    },

    cancelSelection(dateTimeMS) {
      this.$store.dispatch("selections/cancelSelection", dateTimeMS);
    },

    /* ================ MATCH POOL HANDLERS ================ */
    hasBestMatch(dateTimeMS) {
      return this.matchPool[dateTimeMS] && this.matchPool[dateTimeMS].length && this.matchPool[dateTimeMS].length >= 1;
    },
    getBestMatch(dateTimeMS) {
      if (!this.matchPool[dateTimeMS] || !this.matchPool[dateTimeMS].length) {
        return null;
      }
      const bestUser = this.calendarUsers[this.matchPool[dateTimeMS][0].matchableID];
      return {
        displayName: bestUser.metadata.displayName,
        profileImageUrl: bestUser.metadata.profileImageUrl,
        ID: bestUser.metadata.ID,
      };
    },
    hasMorePeople(dateTimeMS) {
      return this.matchPool[dateTimeMS] && this.matchPool[dateTimeMS].length && this.matchPool[dateTimeMS].length > 1;
    },
    /**
     * @return {Array} for every person in match pool for this datetime, the following object:
     *  {
     *    displayName: {String}
     *    profileImageUrl: {String}
     *  }
     */
    getOtherAvailablePeople(dateTimeMS) {
      const currentArray = this.matchPool[dateTimeMS];
      const returnArray = [];
      for (let i = 0; i < currentArray.length; i++) {
        const user = this.calendarUsers[currentArray[i].matchableID];
        returnArray.push({
          displayName: user.metadata.displayName,
          profileImageUrl: user.metadata.profileImageUrl,
          ID: user.metadata.ID,
        });
      }
      return returnArray;
    },
    /* ================ SELECTION DATA ================ */
    toggleSelectionRematch(dateTimeMS) {
      console.log("toggling rematch!", dateTimeMS);
      this.$store.dispatch("selections/setSelectionField", {
        dateTimeMS,
        field: "rematch",
        newValue: !this.selectionSessionData[dateTimeMS].currentUserSession.rematch,
      });
    },

    /* ================ BOOKING ================ */
    bookManySessions() {
      console.log("BOOKING SESSION DATA: ", this.selectionSessionData);
      console.log("BOOKING SESSIONS: ", this.selectedDateTimes);
      /** @TODO WHY NO ASYNC-AWAIT HERE ? */
      if (this.selectedDateTimes.length) {
        if (this.selectedDateTimes.length === 1) {
          StoreMatchController.bookSession(this.selectedDateTimes[0]);
        } else {
          StoreMatchController.bookManySessions(this.selectedDateTimes);
        }
      }
    },
    async cancelAllBookings() {
      for (let i = this.selectedDateTimes.length; --i >= 0; ) {
        await this.$store.dispatch("selections/cancelSelection", this.selectedDateTimes[i]); // TODO
      }
    },
  },
};

function generateDateGroupToSortedSelections(dateTimeMS) {
  return {
    shortDate: format(dateTimeMS, "eee"),
    dateNum: getDate(dateTimeMS),
    selections: [dateTimeMS],
  };
}

function generateMonthGroupToSortedSelections(dateTimeMS) {
  return {
    month: format(dateTimeMS, "MMM"),
    monthNum: getMonth(dateTimeMS),
    dates: [generateDateGroupToSortedSelections(dateTimeMS)],
  };
}

function generateYearGroupToSortedSelections(dateTimeMS) {
  return {
    year: getYear(dateTimeMS),
    months: [generateMonthGroupToSortedSelections(dateTimeMS)],
  };
}

function sortSortedSelections(sortedSelections) {
  sortedSelections.sort((a, b) => a.year - b.year);
  for (let i = 0; i < sortedSelections.length; i++) {
    sortedSelections[i].months.sort((a, b) => a.monthNum - b.monthNum);
    for (let j = 0; j < sortedSelections[i].months.length; j++) {
      sortedSelections[i].months[j].dates.sort((a, b) => a.dateNum - b.dateNum);
    }
  }
  return sortedSelections;
}

/* 
groups = [
  {
    year: "2021",
    months: [
      {
        month: "april",
        monthNum: {Number} 0...11
        dates: [
          {
            date: "someDate",
            dateNum: {Number} 0...31
            selections: [selection1, selection2],
          }
        ],
      }
    ]
  }
]
*/

function generateSortedSelections(selectedDateTimes) {
  const groups = [];
  for (let i = 0; i < selectedDateTimes.length; i++) {
    let dateTimeMS = selectedDateTimes[i];
    let year = getYear(dateTimeMS);
    let monthNum = getMonth(dateTimeMS);
    let dateNum = getDate(dateTimeMS);

    let yearIndex = groups.findIndex((group) => group.year === year);

    if (yearIndex < 0) {
      groups.push(generateYearGroupToSortedSelections(dateTimeMS));
    } else {
      let months = groups[yearIndex].months;
      let monthIndex = months.findIndex((month) => month.monthNum === monthNum);
      if (monthIndex < 0) {
        groups[yearIndex].months.push(generateMonthGroupToSortedSelections(dateTimeMS));
      } else {
        let dates = months[monthIndex].dates;
        let dateIndex = dates.findIndex((date) => date.dateNum === dateNum);
        if (dateIndex < 0) {
          groups[yearIndex].months[monthIndex].dates.push(generateDateGroupToSortedSelections(dateTimeMS));
        } else {
          groups[yearIndex].months[monthIndex].dates[dateIndex].selections.push(dateTimeMS);
        }
      }
    }
  }
  return sortSortedSelections(groups);
}
</script>
<style scoped>
.rematch {
  border: 2px solid green;
}

.bookerMini {
  display: flex;
  flex-direction: row;
}
.bookerMini .selections {
  display: flex;
  flex-direction: row;
  max-width: 840px;
  overflow-x: scroll;
  overflow-y: hidden;
  padding: 4px;
  margin-right: 20px;
}
.bookerMini .selections .selection {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: unset !important;
  margin: 0px !important;
  margin-left: 12px !important;
  box-shadow: rgb(179 179 179 / 42%) 0px 1px 4px 0px !important;
  padding: 8px 12px !important;
  box-sizing: border-box;
  border-radius: 360px;
  background-color: #fafafb;
  position: relative;
  background: var(--calendar-box-background);
  border-color: var(--calendar-box-border-color);
  border-width: var(--calendar-box-border-width);
  /* border-radius: var(--calendar-box-border-radius); */
  background-size: cover;
}
.bookerMini .confirm {
  font-size: 20px;
  letter-spacing: 0.5px;
  padding: 4px 14px;
  font-weight: 600;
  border-radius: 360px;
  cursor: pointer;
  transition: 0.1s ease;
  text-align: center;
  outline: none;
  border-color: unset;
  border: none;
  box-sizing: border-box;
  width: 285px;
  width: 235px;
  margin: auto;
  font-family: "Nunito", sans-serif;
  background-color: #2b2c2d;
  color: white;
}
.bookerMini .confirm:hover {
  background-color: #49494c;
}
.bookerMini .actions {
  justify-content: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: auto;
}
.bookerMini .cancelAll {
  cursor: pointer;
  font-size: 20px;
  letter-spacing: 0.5px;
  padding: 4px 14px;
  font-weight: 600;
  border-radius: 360px;
  cursor: pointer;
  transition: 0.1s ease;
  text-align: center;
  outline: none;
  border-color: unset;
  border: none;
  box-sizing: border-box;
  width: 160px;
  margin: auto;
  font-family: "Nunito", sans-serif;
  background-color: #555;
  color: white;
  min-height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}
.bookerMini .cancelAll:hover {
  background-color: #777;
}
.bookerMini .selection .picture {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 35px;
  height: 35px;
  min-width: 35px;
  max-height: 35px;
  border-radius: 360px;
  justify-content: center;
  box-sizing: border-box;
  object-fit: cover;
  border: 2px solid #eaeaea;
  border-color: #e4e4e4;
  border-color: var(--calendar-box-time-border-color);
}
.bookerMini .selection .profile {
  align-items: center;
}
.bookerMini .selection .profile .name {
  font-size: 17px;
  padding: 8px 10px;
  font-weight: 600;
  color: #2d2d2d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: var(--calendar-box-name-color);
}
.bookerMini .selection .profile .name:hover {
  text-decoration: underline;
}
.bookerMini .selection .empty {
  font-size: 17px;
  padding: 8px 10px;
  font-weight: 600;
  color: #2d2d2d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: var(--calendar-box-name-color);
}
.bookerMini .selection .time {
  font-size: 14px;
  margin-left: auto;
  text-align: center;
  border-radius: 360px;
  box-sizing: border-box;
  padding: 5px 8px;
  font-weight: bold;
  align-items: center;
  border-top: 0px;
  box-shadow: none;
  border: 1px solid #eaeaea;
  color: #323333;
  background-color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 100px;
  /* max-width: 150px; */
  color: var(--calendar-box-time-color);
  background: var(--calendar-box-time-background);
  border-width: var(--calendar-box-time-border-width);
  border-color: var(--calendar-box-time-border-color);
  border-radius: var(--calendar-box-time-border-radius);
}
.bookerMini .selection .cancel {
  margin-left: auto;
  border-radius: 360px;
  padding: 5px 8px;
  font-weight: bold;
  position: absolute;
  right: 15px;
  box-sizing: border-box;
  background-color: #4a4d4ed4;
  width: 28px;
  height: 28px;
  color: white;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  text-align: center;
  padding-top: 4px;
  z-index: 9999;
  display: none;
  cursor: pointer;
}
.bookerMini .selection .cancel:hover {
  background-color: #868a8c;
}

.bookerMini .selection:hover .cancel {
  display: block !important;
}

@media screen and (max-width: 900px) {
  .bookerMini .selections {
    display: none;
  }
  .bookerMini .actions {
    margin-right: auto;
  }
  .bookerMini .confirm,
  .bookerMini .cancelAll {
    font-size: 18px;
  }
  .bookerMini .confirm {
    width: 200px;
  }
  .bookerMini .cancelAll {
    width: 120px;
  }
}
</style>
